// extracted by mini-css-extract-plugin
export default {"ad":"ad_ad__kVXP7","close":"ad_close__9MWI7","containerId":"ad_containerId__5-akM"};